var React = require('react');

function BookingCalendar (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.7734 1.48438H15.8828V0H14.3984V1.48438H4.60156V0H3.11719V1.48438H2.22656C0.998836 1.48438 0 2.48321 0 3.71094V16.7734C0 18.0012 0.998836 19 2.22656 19H12.7844L19 12.5453V3.71094C19 2.48321 18.0012 1.48438 16.7734 1.48438ZM13.2109 16.4171V13.7305C13.2109 13.3212 13.5439 12.9883 13.9531 12.9883H16.5127L13.2109 16.4171ZM17.5156 11.5039H13.9531C12.7254 11.5039 11.7266 12.5027 11.7266 13.7305V17.5156H2.22656C1.81732 17.5156 1.48438 17.1827 1.48438 16.7734V6.97656H17.5156V11.5039ZM17.5156 5.49219H1.48438V3.71094C1.48438 3.3017 1.81732 2.96875 2.22656 2.96875H3.11719V4.45312H4.60156V2.96875H14.3984V4.45312H15.8828V2.96875H16.7734C17.1827 2.96875 17.5156 3.3017 17.5156 3.71094V5.49219Z","fill":"#667778"}));
}

BookingCalendar.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19","fill":"none"};

module.exports = BookingCalendar;

BookingCalendar.default = BookingCalendar;
